import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import Typography from '@material-ui/core/Typography';
import { SESSION_EXPIRED_EVENT } from '../API/sessionManager';

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

class SessionExpiredDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
  }

  componentDidMount() {
    window.addEventListener(SESSION_EXPIRED_EVENT, this.handleSessionExpired);
  }

  componentWillUnmount() {
    window.removeEventListener(SESSION_EXPIRED_EVENT, this.handleSessionExpired);
  }

  handleSessionExpired = () => {
    this.setState({ open: true });
  };

  handleLoginAgain = () => {
    window.location = '/memberLogin';
  };

  render() {
    const { open } = this.state;
    return (
      <div>
        <Dialog aria-labelledby="session-expired-dialog-title" open={open} maxWidth="sm">
          <DialogContent dividers>
            <Typography gutterBottom className="alert-header">
              <b>Session expired</b>
            </Typography>
            <Typography gutterBottom className="alert-text">
              Your session has expired. Please log in again to continue.
            </Typography>
          </DialogContent>
          <DialogActions>
            <div id="Log in again">
              <Button className="alert-STAY" onClick={this.handleLoginAgain}>
                <b>Log in again</b>
              </Button>
            </div>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default SessionExpiredDialog;
